var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "nav-segment" }, [
      _c(
        "div",
        { staticClass: "nav-wrapper" },
        [
          _c("i", { staticClass: "vertical-line" }),
          _c(
            "router-link",
            {
              staticClass: "about-nav active-nav",
              attrs: { to: { name: "About1" } }
            },
            [_vm._v("企业公告"), _c("i")]
          ),
          _c(
            "div",
            { staticClass: "nav-margin" },
            [
              _c(
                "router-link",
                {
                  staticClass: "about-nav active-nav",
                  attrs: { to: { name: "Conact1" } }
                },
                [_vm._v("新闻动态"), _c("i")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "nav-margin" },
            [
              _c(
                "router-link",
                {
                  staticClass: "about-nav active-nav",
                  attrs: { to: { name: "problem1" } }
                },
                [_vm._v("常见问题"), _c("i")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "nav-margin" },
            [
              _c(
                "router-link",
                {
                  staticClass: "about-nav active-nav",
                  attrs: { to: { name: "knowledge1" } }
                },
                [_vm._v("知识拓展"), _c("i")]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrap" }, [
      _c("span", { staticClass: "tit" }, [_vm._v("发现不一样的支付")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }